import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { SortableElement } from 'react-sortable-hoc';
import keycode from 'keycode';
import _ from 'lodash';
import DragHandle from '../../../../common/ui/DragHandle';
import { RenderField } from '../../../../common/form';
import * as Validations from '../../../../common/form/commonValidations';

function isUnique(value, allValues) {
  let count = 0;
  allValues.meal_options.forEach(mealOption => {
    if (mealOption.name && value && mealOption.name.toLowerCase() === value.toLowerCase()) {
      count += 1;
    }
  });
  return count > 1 ? 'Duplicate Meal Option' : undefined;
}

class RenderMealOption extends Component {
  constructor(props) {
    super(props);

    this.toggleEditing = this.toggleEditing.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleEnter = this.handleEnter.bind(this);

    this.state = {
      editing: false,
    };
  }

  componentWillMount() {
    const { fieldIndex, fields } = this.props;
    const field = fields.get(fieldIndex);
    const { editing } = field;
    if (editing) {
      this.setState({
        editing: true,
      });
    }
  }

  toggleEditing() {
    this.setState(prevState => ({
      editing: !prevState.editing,
    }));
  }

  handleDelete(mealOptionCount) {
    const { fieldIndex, fields, onDeleteMealOption } = this.props;
    const deleteAction = () => fields.remove(fieldIndex);
    if (mealOptionCount) {
      const rsvpQuestion = fields.get(fieldIndex);
      onDeleteMealOption(rsvpQuestion, deleteAction);
    } else {
      deleteAction();
    }
  }

  handleBlur(e, newValue) {
    if (newValue !== '' && newValue.length <= 100) {
      this.toggleEditing();
    }
  }

  handleEnter(e) {
    const { value } = e.target;
    if (keycode(e) === 'enter') {
      e.preventDefault();
      if (value !== '' && value.length <= 100) {
        this.toggleEditing();
      }
    }
  }

  render() {
    const { mealOption, fieldIndex, fields, mealOptionCounts } = this.props;
    const { editing } = this.state;
    const mealOptionCount = mealOptionCounts[fields.get(fieldIndex).id];
    return (
      <div className="sortable-meal-option-row">
        {editing ? (
          <div className="meal-option-row">
            <DragHandle tooltip="Drag to reorder" />
            <Field
              name={`${mealOption}.name`}
              component={RenderField}
              type="text"
              className="meal-option-name meal-option-name-editing"
              placeholder="Chicken"
              validate={Validations.MAX_LENGTH_100}
              warn={isUnique}
              maxChars={100}
              hideFormGroups
              onBlur={this.handleBlur}
              onKeyDown={this.handleEnter}
            />
            <div
              role="button"
              className="meal-option-delete"
              onClick={() => this.handleDelete(mealOptionCount)}
            >
              <i className="zolaicon zolaicon-trashcan" />
            </div>
            {mealOptionCount && (
              <div className="meal-option-count meal-option-count-editing">
                {mealOptionCount} {mealOptionCount.length === 1 ? 'Guest' : 'Guests'} Selected
              </div>
            )}
          </div>
        ) : (
          <div className="meal-option-row" style={{ position: 'relative' }}>
            <DragHandle tooltip="Drag to reorder" />
            <span className="meal-option-name meal-option-name-display">
              {_.capitalize(fields.get(fieldIndex).name)}
            </span>
            <div role="button" className="meal-option-edit" onClick={this.toggleEditing}>
              {/* <i className="glyphicon glyphicon-pencil" /> */}
              <i className="zolaicon zolaicon-edit" />
            </div>
            {mealOptionCount && (
              <div className="meal-option-count">
                {mealOptionCount} {mealOptionCount.length === 1 ? 'Guest' : 'Guests'} Selected
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

RenderMealOption.propTypes = {
  mealOption: PropTypes.string,
  fieldIndex: PropTypes.number,
  fields: PropTypes.shape({}),
  mealOptionCounts: PropTypes.shape({}),
  onDeleteMealOption: PropTypes.func,
};

const SortableMealOptionField = SortableElement(props => <RenderMealOption {...props} />);

export default SortableMealOptionField;



// WEBPACK FOOTER //
// ./src/components/manage/common/EventForm/SortableMealOptions/SortableMealOptionField.jsx